import httpRequest from '@/request'


const API = {
  LOGIN: '/front/energygov/v1/login',//登录
  USERINFO: '/front/energygov/v1/login/userInfo', //登录后获取用户信息
}

export function loginFun(data: any) {
  return httpRequest({
    url: API.LOGIN,
    method: 'post',
    data
  })
}
export function getUserInfoRequest(){
    return httpRequest({
        url:API.USERINFO,
        method:'get',
    })
}
